// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4b7e4a51","455":"2107f505","977":"31bc9035"}[chunkId] + ".chunk.js";
};